var map = {
	"./goldcoin/airdrop-freemint.png": 5702,
	"./memetown/airdrop-freemint.png": 1275,
	"./reflection/airdrop-freemint.png": 78864,
	"./tapcoin/airdrop-freemint.png": 44746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74725;